/**
 * Assets: uvt-filter.js
 * -----------------------------------------------------------------------------
 * Pagination dots for the stat rail in sections/uvt-filter.liquid.
 * Uses uvt.initDots from uvt-base.js, which must load first.
 * Re-initialises when the section is re-rendered in the theme editor.
 *
 */
(() => {
  /**
   * Sets up the dots in every filter section inside a container.
   * @param {ParentNode} container - Document or re-rendered section.
   */
  function initAll(container) {
    if (!window.uvt) {
      return;
    }

    container.querySelectorAll('[data-uvt-filter]').forEach((root) => {
      window.uvt.initDots(
        root.querySelector('[data-uvt-rail]'),
        Array.from(root.querySelectorAll('[data-uvt-dot]')),
      );
    });
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
